import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../../services/CommonService';
import _ from 'lodash';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class HtmlConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.scanForParams();
		this.autoBind(['buildTypeDefault', 'scanForParams', 'onSetEmpty', 'onClearValue', 'onDefaultChange', 'getIsDisabled']);
	}

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}
		return {
			testing: false,
			authOpen: false,
			outputDefOpen: false,
			headersOpen: false,
			bodyOpen: false,
			querystringOpen: false,
			sslOpen: true,
			agents: [],
			agentContent: '',
			agentsOpen: false,
			actionType: 'get',
			name: '',
			url: '',
			path: '',
			username: '',
			password: '',
			token: '',
			timeout: 0,
			parseJsonResponse: true,
			authType: 'basic',
			outputDefContent: '',
			headersContent: '',
			bodyContent: '',
			querystringContent: '',
			sslContent: '',
			runningTest: false,
			requestParams: {},
			disabled: {}
		};
	};

	onBuildConnectionState(conn) {
		let config = conn.configuration;
		let auth = config.auth || {};

		let state = {
			testing: conn.testing,
			actionType: 'get',
			authOpen: auth && auth.authType ? true : false,
			outputDefOpen: config.template ? true : false,
			headersOpen: config.headers ? true : false,
			bodyOpen: config.body ? true : false,
			querystringOpen: config.qs ? true : false,
			agents: this.data.agents ? this.data.agents : [],
			agentContent: conn.agent ? conn.agent : '',
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			name: conn.name,
			type: conn.type,
			url: config.url ? config.url : '',
			path: config.path ? config.path : '',
			timeout: config.timeout ? config.timeout : 0,
			parseJsonResponse: config.json,
			sslOpen: config.strictSSL,
			authType: auth.authType ? auth.authType : 'basic',
			username: auth.username ? auth.username : '',
			password: auth.password ? auth.password : '',
			token: auth.token ? auth.token : '',
			outputDefContent: config.template ? JSON.stringify(config.template.output, undefined, 2) : '',
			headersContent: config.headers ? JSON.stringify(config.headers, undefined, 2) : '',
			bodyContent: config.body ? JSON.stringify(config.body, undefined, 2) : '',
			querystringContent: config.qs ? JSON.stringify(config.qs, undefined, 2) : '',
			runningTest: false,
			requestParams: {},
			disabled: {}
		};

		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.path.length > 0) {
				disabled.path = true;
			}
			if (state.authOpen) {
				disabled.auth = true;
			}
			if (state.headersContent.length > 0) {
				disabled.headersContent = true;
			}
			if (state.bodyContent.length > 0) {
				disabled.body = true;
			}
			if (state.outputDefContent.length > 0) {
				disabled.outputDefContent = true;
			}
			if (state.querystringContent.length > 0) {
				disabled.querystringContent = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;
		return state;
	}

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
			this.scanForParams();
		});
	};

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onActionChange = evt => {
		this.setData('actionType', evt.value);
	};

	onToggleParse = () => {
		this.setData('parseJsonResponse', !this.data.parseJsonResponse);
	};

	onAuthChange = evt => {
		this.setData('authType', evt.value);
	};

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	buildTestConnection = () => {
		let connection = this.onBuildConnection();
		let is = this.onBuildConnectionState(this.props.connection);
		let config = {};
		if (is.path.length <= 0 && this.data.path.length > 0) {
			config.path = connection.configuration.path;
		}
		if (!is.authOpen && this.data.authOpen) {
			config.auth = connection.configuration.auth;
		}
		if (!is.bodyOpen && this.data.bodyOpen) {
			config.body = connection.configuration.body;
		}
		if (!is.headersOpen && this.data.headersOpen) {
			config.headers = connection.configuration.headers;
		}
		if (!is.outputDefOpen && this.data.outputDefOpen) {
			config.template = connection.configuration.template ? connection.configuration.template : {};
			config.template.output = connection.configuration.template.output;
		}
		if (!is.querystringOpen && this.data.querystringOpen) {
			config.qs = connection.configuration.qs;
		}

		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				action: connection.actionType,
				configuration: config,
				connection: connection.name,
				type: 'Operation',
				templates: CS.buildRequestTemplate(this.data.requestParams)
			},
			testValues: testData
		};
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	isValidConnection = () => {
		let data = this.data;

		if (data.name.length === 0) {
			return true;
		}

		if (data.authOpen) {
			if (data.authType === 'basic') {
				if (data.username.length === 0 && data.password === 0) {
					return true;
				}
			} else if (data.authType === 'bearer') {
				if (data.token.length === 0) {
					return true;
				}
			}
		}

		if (data.headersOpen) {
			if (data.headersContent.length === 0) {
				return true;
			}
		}

		if (data.bodyOpen) {
			if (data.bodyContent.length === 0) {
				return true;
			}
		}

		if (data.querystringOpen) {
			if (data.querystringContent.length === 0) {
				return true;
			}
		}

		return false;
	};

	onCreateConnection = () => {
		RS.showSuccess();
	};

	handleOutputDefChange = newValue => {
		this.observe(() => {
			this.data.outputDefContent = newValue;
			this.scanForParams();
		});
	};

	handleHeadersChange = newValue => {
		this.observe(() => {
			this.data.headersContent = newValue;
			this.scanForParams();
		});
	};

	handleBodyChange = newValue => {
		this.observe(() => {
			this.data.bodyContent = newValue;
			this.scanForParams();
		});
	};

	handleQueryStringChange = newValue => {
		this.observe(() => {
			this.data.querystringContent = newValue;
			this.scanForParams();
		});
	};

	onBuildConnection = () => {
		let data = this.data;
		this.invalidForm = false;
		let connection = {
			name: data.name,
			type: 'html-connector',
			configuration: {
				url: data.url,
				json: data.parseJsonResponse,
				strictSSL: data.sslOpen
			}
		};

		if (data.testing) {
			connection.actionType = data.actionType;
		}

		if (data.path.length > 0) {
			connection.configuration.path = data.path;
		}
		if (data.timeout >= 0) {
			connection.timeout = data.timeout;
		}

		if (data.authOpen) {
			connection.configuration.auth = {
				type: data.authType
			};

			if (data.authType === 'basic') {
				connection.configuration.auth.username = data.username;
				connection.configuration.auth.password = data.password;
			} else if (data.authType === 'bearer') {
				connection.configuration.auth.token = data.token;
			}
		}

		if (data.outputDefOpen) {
			let val = CS.safelyParseJSON(data.outputDefContent);
			if (!val) {
				this.invalidForm = true;
				return;
			}
			let outputJson = val;
			connection.configuration.template = {
				output: outputJson
			};
		}

		if (data.headersOpen) {
			let val = CS.safelyParseJSON(data.headersContent);
			if (!val) {
				this.invalidForm = true;
				return;
			}
			connection.configuration.headers = val;
		}

		if (data.bodyOpen) {
			let val = CS.safelyParseJSON(data.bodyContent);
			if (!val) {
				this.invalidForm = true;
				return;
			}
			connection.configuration.body = val;
		}

		if (data.querystringOpen) {
			let val = CS.safelyParseJSON(data.querystringContent);
			if (!val) {
				this.invalidForm = true;
				return;
			}
			connection.configuration.qs = val;
		}

		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}

		return connection;
	};

	scanForParams() {
		let keys = ['path', 'url', 'outputDefContent', 'headersContent', 'bodyContent', 'querystringContent'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(res => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	render() {
		let {
			testing,
			actionType,
			authOpen,
			headersOpen,
			outputDefOpen,
			agentsOpen,
			agentContent,
			bodyOpen,
			querystringOpen,
			sslOpen,
			name,
			url,
			path,
			timeout,
			username,
			password,
			token,
			parseJsonResponse,
			authType,
			outputDefContent,
			headersContent,
			bodyContent,
			runningTest,
			querystringContent,
			async
		} = this.data;

		return (
			<div className="html-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
					</div>
					<div className="hbox">
						<InputField
							className="m-r-10"
							label="URL"
							subText="Base URL of the REST service."
							type="text"
							name="url"
							value={url}
							handleChange={this.onValueChange}
							disabled={testing}
						/>

						<InputField
							className="m-r-10"
							name="path"
							label="Path"
							value={path}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('path')}
							subText="Path to append to the base URL."
							type="text"
						/>
					</div>
					<div className="hbox field-ctn">
						<InputField
							label="Timeout"
							subText="Optional time to wait for the response headers in miliseconds. This must be lower than the global Platform timeout (10s)"
							type="number"
							name="timeout"
							value={timeout}
							handleChange={this.onValueChange}
						/>
						<div className="hbox vcenter checkbox-col">
							<input type="checkbox" checked={parseJsonResponse} onChange={this.onToggleParse} disabled={testing} />
							<div className="label">Parse JSON response</div>
						</div>
					</div>
					<ToggleRow
						name="User Authentication"
						details="Enable if the REST service requires authentication."
						toggleOn={authOpen}
						keyName={'authOpen'}
						onToggle={this.onChecked}
						content={
							<div>
								<div className="auth-content hbox vcenter">
									<Dropdown
										className="auth-dd m-r-20"
										label="Type"
										value={authType}
										handleChange={this.onAuthChange}
										name="authType"
										disabled={this.getIsDisabled('auth')}
										options={[
											{
												label: 'Basic',
												value: 'basic'
											},
											{
												label: 'Bearer',
												value: 'bearer'
											}
										]}
									/>
									{authType === 'basic' && [
										<InputField
											className="m-r-20"
											key="http-connector-username-key"
											label="Username"
											type="text"
											name="username"
											value={username}
											disabled={this.getIsDisabled('auth')}
											handleChange={this.onValueChange}
										/>,
										<InputField
											className="m-r-20"
											key="http-connector-password-key"
											label="Password"
											type="password"
											name="password"
											value={password}
											disabled={this.getIsDisabled('auth')}
											handleChange={this.onValueChange}
										/>
									]}
									{authType === 'bearer' && (
										<InputField
											className="m-r-20"
											label="Token"
											type="text"
											name="token"
											value={token}
											handleChange={this.onValueChange}
											disabled={this.getIsDisabled('auth')}
										/>
									)}
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="Output Definitions"
						details={
							this.props.endpoint
								? 'Specify how the HTML response will be parsed to produce a JSON result.'
								: "Note that if you define output definitions at connection-level you won't be able to define them at endpoint-level."
						}
						toggleOn={outputDefOpen}
						keyName={'outputDefOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor
									name="headers"
									value={outputDefContent}
									onChange={this.handleOutputDefChange}
									readOnly={this.getIsDisabled('outputDefContent')}
								/>
							</div>
						}
					/>
					<ToggleRow
						name="Headers"
						details={
							this.props.endpoint
								? 'Define any specific header required by the REST service.'
								: "Note that if you define headers at connection-level you won't be able to define any header at endpoint-level."
						}
						toggleOn={headersOpen}
						keyName={'headersOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor
									name="headers"
									value={headersContent}
									onChange={this.handleHeadersChange}
									readOnly={this.getIsDisabled('headersContent')}
								/>
								<div className="json-message">Define headers as JSON, using keys for the header names and values for header values.</div>
							</div>
						}
					/>
					<ToggleRow
						name="Body"
						details={
							this.props.endpoint
								? 'Data to be sent to the external service in the request body.'
								: "Note that if you define a body at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={bodyOpen}
						keyName={'bodyOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor name="headers" value={bodyContent} onChange={this.handleBodyChange} readOnly={this.getIsDisabled('bodyContent')} />
								<div className="json-message">The request body must be defined as a valid JSON object</div>
							</div>
						}
					/>
					<ToggleRow
						name="Query String"
						details={
							this.props.endpoint
								? 'Optional query string to append to the execution URL.'
								: "Note that if you define a query string at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={querystringOpen}
						keyName={'querystringOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor
									name="headers"
									value={querystringContent}
									onChange={this.handleQueryStringChange}
									readOnly={this.getIsDisabled('querystringContent')}
								/>
								<div className="json-message">
									Define the query string as JSON, using keys for the variable names and values for variables values.
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="SSL Certificate Validation"
						details="The SSL validation can be disabled altogether in order to request servers using a certificate signed by an unknown Certificate Authority or a self-signed certificate. This is insecure and is recommended for testing purposes only."
						toggleOn={sslOpen}
						keyName={'sslOpen'}
						onToggle={this.onChecked}
						offContent={
							<div className="json-message">
								<i className="mdi mdi-alert" /> Insecure
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									onTest={this.runTest}
									async={async}
									toggleAsync={this.toggleAsync}
									content={
										<div className="hbox hright">
											<Dropdown
												className="test-action-dd"
												label="Test Action"
												value={actionType}
												handleChange={this.onActionChange}
												name="actionType"
												options={[
													{
														label: 'GET',
														value: 'get'
													},
													{
														label: 'POST',
														value: 'post'
													}
												]}
											/>
										</div>
									}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					{!this.props.endpoint && (
						<div className="btn-ctn">
							<button className="btn m-r-20" onClick={this.onClearConnection}>
								{this.props.connection ? 'Undo Changes' : 'Clear'}
							</button>
							<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
								{this.props.connection ? 'Save Connection' : 'Create Connection'}
							</button>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default HtmlConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/html-connector/HtmlConnector.js